/**
 * Contains the paths used for routing
 */

export const PATHS = {
  root: "/",
  groups: "/groups",
  users: "/users",
  components: "/components",
  privacy: "/privacy",
  imprint: "/imprint",
  register: "/register",
  releaseNotes: "/release-notes",
  copyright: "/copyright",
  thirdPartyNotices: "/third-party-notices",
};
